export default __webpack_public_path__ + "static/media/chainlink.47fc396a.png";